<template>
  <main class="empty-layout">
    <slot />
  </main>
</template>
